       <template>
  <!-- <div class="button"> -->
  <button :class="btn_cls" @click="btnClick()">{{btn_txt}}</button>
  <!-- </div> -->
</template>

<script>
export default {
  name: "Btn",
  props: {
    btn_txt: {
      required: true,
      type: String
    },
    btn_cls: {
      required: true,
      type: String
    }
  },
  data() {
    return {};
  },
  methods: {
    btnClick() {
      this.$emit("goToDashCallback");
      this.$emit("goToFanDetailsCallback");
      this.$emit("acceptRequestCallback");
      this.$emit("declineRequestCallback");
      this.$emit("uploadVideoCallBack");
      this.$emit("skipBtn");
      this.$emit("submitBtn");
      this.$emit("cancelVideo");
      this.$emit("uploadVideo");
    }
  }
};
</script>
